export enum MachineOwnerType {
    Internal = 1,
    External = 2
}

export const MachineOwnerTypeLabels = {
    [MachineOwnerType.Internal]: "Sveaskog",
    [MachineOwnerType.External]: "Entreprenör"
}